export default __webpack_public_path__ + "static/media/rar.3b7ca65c.png";